/**
 * Color constants for PNG illustration workflow stages
 * Matches status values from Core\Entity\Voc on backend
 */

export const ILLUSTRATION_STAGE_COLORS = {
  // No illustration states
  WITHOUT_IMAGE: '#999999', // Gray - will never have illustration
  NO_IMAGE: '#ff0000', // Red - no illustration yet

  // Processing stages
  PNG_UPLOADED: '#ffcc00', // Yellow/Orange - original PNG uploaded (stage 1)
  ENHANCING: '#ff9900', // Orange - AI enhancing in progress
  DONE: '#00cc00', // Green - AI enhanced with alpha (final)
} as const;

/**
 * Get color for illustration status
 */
export function getIllustrationColor(status: number): string {
  switch (status) {
    case -1: // WITHOUT_IMAGE
      return ILLUSTRATION_STAGE_COLORS.WITHOUT_IMAGE;
    case 0: // NO_IMAGE
      return ILLUSTRATION_STAGE_COLORS.NO_IMAGE;
    case 1: // PNG_UPLOADED
      return ILLUSTRATION_STAGE_COLORS.PNG_UPLOADED;
    case 2: // ENHANCING
      return ILLUSTRATION_STAGE_COLORS.ENHANCING;
    case 3: // DONE
      return ILLUSTRATION_STAGE_COLORS.DONE;
    default:
      return ILLUSTRATION_STAGE_COLORS.NO_IMAGE;
  }
}

/**
 * Get stage label for illustration status
 */
export function getIllustrationStageLabel(status: number): string {
  switch (status) {
    case -1:
      return 'No Image';
    case 0:
      return 'No Image';
    case 1:
      return 'Stage 1';
    case 2:
      return 'Enhancing';
    case 3:
      return 'Done';
    default:
      return 'Unknown';
  }
}
